module.exports = __webpack_public_path__ + "media/images/Kitchen Cabinets Brown Wood tall-dd732437.webp";